var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeCreate = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16.0067 16.0067",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9889 10.7065L10.7045 9.29835V6.70831L12.9889 5.30014C13.1947 5.17331 13.453 5.16773 13.664 5.28556C13.8751 5.40339 14.0058 5.62618 14.0058 5.86789V10.1388C14.0058 10.3805 13.8751 10.6033 13.664 10.7211C13.453 10.8389 13.1947 10.8334 12.9889 10.7065Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.00083,
  y: 4.00167,
  width: 8.70362,
  height: 8.00333,
  rx: 3,
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", null))));
export default SvgTypeCreate;